<template>
    <div class="group relative cursor-help">
        <div
            :class="[
                'px-3 py-1 rounded-full flex justify-center items-center',
                isConnected ? 'bg-green-50' : 'bg-red-50',
            ]"
            v-tooltip="tooltipText"
        >
            <div
                :class="[
                    'text-xs font-medium leading-none',
                    isConnected ? 'text-green-500' : 'text-red-500',
                ]"
            >
                {{ statusLabel }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    status: {
        type: String,
        default: 'CONNECTED',
    },
    connectedDate: {
        type: String,
        default: '',
    },
});

const isConnected = computed(() => {
    return props.status === 'CONNECTED';
});

const statusLabel = computed(() => {
    const labels = {
        CREATED: 'Created',
        PREVENTED: 'Prevented',
        DENIED: 'Denied',
        REJECTED: 'Rejected',
        LOCKED: 'Locked',
        CONNECTED: 'Connected',
        CHALLENGED: 'Action Required',
        IMPEDED: 'Impeded',
        RECONNECTED: 'Reconnected',
        DEGRADED: 'Degraded',
        DISCONNECTED: 'Disconnected',
        DISCONTINUED: 'Discontinued',
        CLOSED: 'Closed',
        DELAYED: 'Delayed',
        FAILED: 'Failed',
        UPDATED: 'Updated',
        DISABLED: 'Disabled',
        IMPORTED: 'Imported',
        RESUMED: 'Resumed',
        EXPIRED: 'Expired',
        IMPAIRED: 'Impaired',
        PENDING: 'Pending',
        INITIATED: 'Connecting',
    };

    return labels[props.status] || props.status;
});

const tooltipText = computed(() => {
    const texts = {
        CREATED: `Created ${props.connectedDate ? ' on ' + props.connectedDate : ''}`,
        PREVENTED: 'Connection prevented',
        DENIED: 'Connection denied',
        REJECTED: 'Connection rejected',
        LOCKED: 'Connection locked',
        CONNECTED: `Connected ${props.connectedDate ? ' on ' + props.connectedDate : ''}`,
        CHALLENGED: 'Connection challenged',
        IMPEDED: 'Connection impeded',
        RECONNECTED: 'Reconnected',
        DEGRADED: 'Connection degraded',
        DISCONNECTED: 'Connection disconnected',
        DISCONTINUED: 'Connection discontinued',
        CLOSED: 'Connection closed',
        DELAYED: 'Connection delayed',
        FAILED: 'Connection failed',
        UPDATED: 'Connection updated',
        DISABLED: 'Data import disabled',
        IMPORTED: 'Connection imported',
        RESUMED: 'Connection resumed',
        EXPIRED: 'Connection expired',
        IMPAIRED: 'Connection impaired',
        PENDING: 'Connection pending',
        INITIATED: 'Connection initiated',
    };

    return texts[props.status] || props.status;
});
</script>
